<template>
  <v-container>
    <h1 class="display-inline">Test</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
  </v-container>
</template>

<script>

import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "TestPage",
  permissions: ["Administer Betaworkflow"],
  components: {
    ActiveApiCalls,
  },
  methods: {},
  computed: {},
  mounted() {
    this.$WfmApi.get("job.api/get/J02448").then(response => console.log(response))
    this.$WfmApi.get("client.api/get/1f9fb7b1-2d28-4815-a850-43130a2cdf33").then(response => console.log(response))
    this.$WfmApi.get("client.api/contact/824508da-371e-432b-bb70-080c70c8c2bc").then(response => console.log(response))
  },
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>